/*
 * Modular bridge between Shopify's Theme Editor lifecycle and the Alpine
 * components that consume them.
 *
 * The platform fires `shopify:block:select` / `shopify:block:deselect` on the
 * block element itself, but section components live on the section root and
 * are the natural place to react. This script relays the platform events as
 * `editor:block-select` / `editor:block-deselect` CustomEvents dispatched on
 * the nearest `.shopify-section` ancestor, with `detail.block` pointing at
 * the originating block element.
 *
 * Sections subscribe with a single Alpine directive:
 *
 *     @editor:block-select="onBlockSelect($event)"
 *     @editor:block-deselect="onBlockDeselect($event)"
 *
 * Section load / unload are handled by Alpine itself (MutationObserver
 * auto-initialises new x-data subtrees and calls `destroy()` on removed
 * components), so no bridging is required for those events.
 */
(function () {
  if (window.__themeEditorBridge) return;
  window.__themeEditorBridge = true;

  function relay(eventName, blockEl) {
    var section = blockEl && blockEl.closest ? blockEl.closest('.shopify-section') : null;
    if (!section) return;
    section.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: { block: blockEl },
    }));
  }

  document.addEventListener('shopify:block:select', function (event) {
    relay('editor:block-select', event.target);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    relay('editor:block-deselect', event.target);
  });
})();
